module.exports = __webpack_public_path__ + "static/media/sack-dollar.bcafe5ae.svg";